import React, {PureComponent} from 'react'
import injectSheet from "react-jss";
import cn from "classnames";
import Cookies from "universal-cookie";

export const ELIGIBLE_COUNTRIES = [
    'WP', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL',
    'ES', 'FI', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV',
    'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'
];

export class GDPRPopup extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isClientFullyLoaded: false,
            hasAlreadyViewed: true,
            isEligibleToShow: false
        };

        this.markViewed = this.markViewed.bind(this);
    }

    get displayPopup() {
        const { isClientFullyLoaded, isEligibleToShow, hasAlreadyViewed } = this.state;

        return isClientFullyLoaded && isEligibleToShow && !hasAlreadyViewed;
    }

    componentWillMount() {
        const cookies = new Cookies();

        let hasAlreadyViewed = false;

        if (typeof localStorage !== 'undefined' && localStorage.getItem('ngStorage-gdpr.popup.visited') === 'true') {
            hasAlreadyViewed = true;
        } else if (cookies.get('eu_consent') === 'true') {
            hasAlreadyViewed = true;
        }

        this.setState({
            hasAlreadyViewed: hasAlreadyViewed
        });
    }

    componentDidMount() {
        const {countryCode} = this.props;

        this.setState({
            isClientFullyLoaded: true,
            isEligibleToShow: this.isEligibleToShow(countryCode)
        });
    }

    componentWillReceiveProps(nextProps) {
        const { countryCode } = nextProps;

        this.setState({
            isEligibleToShow: this.isEligibleToShow(countryCode)
        })
    }

    isEligibleToShow(countryCode) {
        return ELIGIBLE_COUNTRIES.some(country => country === countryCode);
    }

    markViewed() {
        const cookies = new Cookies();

        cookies.set('eu_consent', 'true', { path: '/' });
        localStorage.setItem('ngStorage-gdpr.popup.visited', 'true');

        this.setState({ hasAlreadyViewed: true });
    }

    render() {
        const {classes} = this.props;

        if (this.displayPopup) {
            return (
                <div id="gdpr-popup" className={cn(classes.gdprPopup, classes.gdprPopup['&::Before'])} data-ng-cloak data-ti-gdpr data-ng-show="showGdrpPopup">
                    <div id="gdpr-wrapper" className={classes.gdprWrapper}>
                        <div data-ga-category="EU Guest" data-ga-action="Click" data-ga-label="EU Consent">
                            <div className={classes.imageFrame}>
                                <img
                                    className={classes.image}
                                    src="//img1.theiconic.com.au/OZGaBwkujOI7vK3j0S1Jk-chZbg=/fit-in/478x0/filters:fill(ffffff):quality(50):format(png)/http%3A%2F%2Fstatic.theiconic.com.au%2Fcms%2Frectangle-3%403x-new1.png"
                                    alt="GDPR popup header"
                                />
                            </div>
                            <div className={cn(classes.columns, classes.small12)}>
                                <h2 className={classes.h2GdprTitle}>WELCOME TO THE ICONIC</h2>
                                <i className={classes.ageConfirmText}>Please confirm that you are 16 years old or over.</i>
                            </div>
                            <div className={cn(classes.columns, classes.small12, classes.buttonConfirm)}>
                                <input className={cn(classes.button, classes.primary, classes.action, classes.expand, classes.buttonConfirmInput)} title="Confirm"
                                       type="submit" value="Confirm" id="gdpr-popup-confirm-btn" onClick={this.markViewed} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return '';
    }
}

export const styleSheet = {
    gdprWrapper: {
        border: 0,
        bottom: 'auto',
        display: 'block',
        maxWidth: '288px',
        minHeight: 'initial',
        position: 'fixed',
        zIndex: 1000,
        backgroundColor: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 10px rgba(0,0,0,.4)',
        '-webkit-font-smoothing': 'auto',
    },
    gdprPopup: {
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        height: '100vh',
        width: '100vw',
        zIndex: 1000,
        lineHeight: 1.5,
        '&:Before': {
            content: '""',
            width: '100%',
            height: '100%',
            position: 'fixed',
            background: 'rgba(0,0,0,.15)',
            zIndex: 999
        },
    },
    imageFrame: {
        display: 'block',
        position: 'relative',
        overflow: 'hidden',
        paddingBottom: '50%'
    },
    image: {
        width: '100%',
        height: 'auto',
        left: '50%',
        top: '50%',
        webkitTransform: 'translate(-50%,-50%)',
        transform: 'translate(-50%,-50%)',
        position: 'absolute',
        maxWidth: 'inherit',
    },
    columns: {
        padding: '16px 12px',
    },
    small12: {
        width: '100%'
    },
    h2GdprTitle: {
        fontFamily: 'proxima-nova, sans-serif',
        fontWeight: 700,
        fontSize: '18px',
        margin: '4px 0 8px 0'
    },
    ageConfirmText: {
        fontFamily: 'proxima-nova, sans-serif',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        letterSpacing: '0.4px',
        lineHeight: '21px',
        marginTop: '24px'
    },
    buttonConfirm: {
        boxSizing: 'border-box',
        cursor: 'auto',
        display: 'block',
        float: 'left',
        fontFamily: 'proxima-nova, sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        fontStyle: 'normal',
        height: '82px',
        lineHeight: '24px',
        margin: 0,
        position: 'relative',
        textAlign: 'left',
        visibility: 'visible',
        width: '288px'
    },
    buttonConfirmInput: {
        alignItems: 'flex-start',
        backgroundColor: 'rgb(66, 171, 200)',
        border: '1px solid rgb(66, 171, 200)',
        borderRadius: '2px',
        boxSizing: 'border-box',
        color: '#fff',
        cursor: 'pointer',
        display: 'block',
        fontFamily: 'proxima-nova, sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        fontStretch: '100%',
        fontStyle: 'normal',
        fontVariantCaps: 'normal',
        fontVariantEastAsian: 'normal',
        fontVariantLigatures: 'normal',
        fontVariantNumeric: 'normal',
        height: '50px',
        letterSpacing: 'normal',
        lineHeight: '16px',
        marging: 0,
        minHeight: '48px',
        outlineColor: 'rgb(255, 255, 255)',
        outlineStyle: 'none',
        outlineWidth: '0px',
        textAlign: 'center',
        textDecorationColor: 'rgb(255, 255, 255)',
        textDecorationLine: 'none',
        textDecorationStyle: 'solid',
        textRendering: 'auto',
        textShadow: 'none',
        textSizeAdjust: '100%',
        textTransform: 'uppercase',
        transitionDelay: '0s, 0s',
        transitionDuration: '0.25s, 0.25s',
        transitionProperty: 'background-color, color',
        transitionTimingFunction: 'ease-out, ease-out',
        userSelect: 'none',
        verticalAlign: 'middle',
        visibility: 'visible',
        whiteSpace: 'pre',
        width: '264px',
        wordSpacing: '0px',
        writingMode: 'horizontal-tb',
        '-webkit-appearance': 'none',
        '-webkit-rtl-ordering': 'logical',
        '-webkit-border-image': 'none',
        '&:hover': {
            backgroundImage: 'linear-gradient(rgba(255,255,255,.2), rgba(255,255,255,.2))'
        }
    }
};

export default injectSheet(() => styleSheet)(GDPRPopup)



// WEBPACK FOOTER //
// ./src/components/GDPR/GDPRPopup.js